import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Snackbar } from '@mui/material';
import { Logout, reset } from '../../fitur/AuthSlice';

const CODES = ['CABANG_EXPIRED', 'CABANG_EXPIRED_READONLY', 'FITUR_TIDAK_TERSEDIA'];

// Memantau semua permintaan XHR (axios global maupun instance) dan memberi tahu pengguna
// saat server menolak karena langganan/paket (403 dengan kode khusus).
let terpasang = false;
export const installLanggananWatcher = () => {
  if (terpasang || typeof XMLHttpRequest === 'undefined') return;
  terpasang = true;
  const buka = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metode, url, ...sisa) {
    this.__urlLanggananNotice = String(url || '');
    return buka.call(this, metode, url, ...sisa);
  };
  const kirim = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('loadend', () => {
      try {
        if (this.status !== 403) return;
        // Login yang ditolak (cabang expired) sudah menampilkan pesannya sendiri di halaman login.
        if (/\/login(\?|$)/.test(this.__urlLanggananNotice || '')) return;
        let body = null;
        if (this.responseType === '' || this.responseType === 'text') body = JSON.parse(this.responseText);
        else if (this.responseType === 'json') body = this.response;
        if (body && CODES.includes(body.code)) {
          window.dispatchEvent(new CustomEvent('langganan-blocked', { detail: { code: body.code, message: body.message } }));
        }
      } catch (e) {
        // bukan JSON / tidak bisa dibaca: abaikan
      }
    });
    return kirim.apply(this, args);
  };
};

const LanggananNotice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [snack, setSnack] = useState(null);
  const [expiredDialog, setExpiredDialog] = useState(null);
  const lastShown = useRef(0);

  useEffect(() => {
    const onBlocked = (e) => {
      const { code, message } = e.detail || {};
      if (code === 'CABANG_EXPIRED') {
        setExpiredDialog(message || 'Masa aktif cabang telah berakhir.');
        return;
      }
      // Hindari banjir pesan bila banyak permintaan ditolak bersamaan.
      if (Date.now() - lastShown.current < 4000) return;
      // Banyak halaman sudah menampilkan pesan error server sendiri. Tunggu sebentar: bila pesan yang sama
      // sudah terlihat di layar, jangan tampilkan lagi supaya tidak dobel/menumpuk.
      setTimeout(() => {
        const kunci = String(message || '').slice(0, 40);
        if (kunci && document.body.innerText.includes(kunci)) return;
        if (Date.now() - lastShown.current < 4000) return;
        lastShown.current = Date.now();
        setSnack({ severity: code === 'FITUR_TIDAK_TERSEDIA' ? 'warning' : 'info', text: message });
      }, 600);
    };
    window.addEventListener('langganan-blocked', onBlocked);
    return () => window.removeEventListener('langganan-blocked', onBlocked);
  }, []);

  const keluar = () => {
    setExpiredDialog(null);
    dispatch(Logout());
    dispatch(reset());
    navigate('/');
  };

  const wa = user?.langganan?.kontak?.waLink;

  return (
    <>
      <Snackbar open={Boolean(snack)} autoHideDuration={7000} onClose={() => setSnack(null)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        {snack ? <Alert severity={snack.severity} onClose={() => setSnack(null)} sx={{ width: '100%' }}>{snack.text}</Alert> : <span />}
      </Snackbar>
      <Dialog open={Boolean(expiredDialog)} onClose={keluar}>
        <DialogTitle>Masa aktif cabang berakhir</DialogTitle>
        <DialogContent>
          <DialogContentText>{expiredDialog}</DialogContentText>
          {wa && (
            <Box sx={{ mt: 1 }}>
              <Link href={wa} target="_blank" rel="noreferrer">Hubungi via WhatsApp</Link>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={keluar}>Keluar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LanggananNotice;
